let counter = 0

export default () => --counter
